import React, { useState } from "react";
import { Input, Dropdown, Badge, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import {
  MenuOutlined, SearchOutlined, CalendarOutlined,
  BellOutlined, UserOutlined, LogoutOutlined,
  BankOutlined, DownOutlined,
} from "@ant-design/icons";
import "./StaffTopHeader.css";

function StaffTopHeader({ onToggleSidebar }) {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const username = localStorage.getItem("username") || "Staff";
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
  });

  const handleLogout = () => {
    localStorage.clear();
    navigate("/Staff_Login");
  };

  const profileMenu = {
    items: [
      { key: "1", icon: <UserOutlined />, label: "Dashboard", onClick: () => navigate("/Staff_Panel") },
      { key: "2", icon: <BankOutlined />, label: "Bank Details", onClick: () => navigate("/staff/bank") },
      { type: "divider" },
      { key: "3", icon: <LogoutOutlined />, label: "Logout", danger: true, onClick: handleLogout },
    ],
  };

  const notificationsMenu = {
    items: [
      { key: "1", label: (
        <div className="staff-notif-item">
          <div className="staff-notif-dot success">✓</div>
          <div>
            <div className="staff-notif-title">Withdrawal Approved</div>
            <div className="staff-notif-time">5 min ago</div>
          </div>
        </div>
      )},
      { key: "2", label: (
        <div className="staff-notif-item">
          <div className="staff-notif-dot warning">₹</div>
          <div>
            <div className="staff-notif-title">Commission Credited ₹500</div>
            <div className="staff-notif-time">1 hour ago</div>
          </div>
        </div>
      )},
      { key: "3", label: (
        <div className="staff-notif-item">
          <div className="staff-notif-dot info">👤</div>
          <div>
            <div className="staff-notif-title">New User Assigned</div>
            <div className="staff-notif-time">2 hours ago</div>
          </div>
        </div>
      )},
    ],
  };

  return (
    <header className="staff-top-header">
      <div className="staff-header-left">
        <button className="staff-toggle-btn" onClick={onToggleSidebar}>
          <MenuOutlined />
        </button>
        <div className="staff-header-title">
          <h1>Staff Dashboard</h1>
          <p>Welcome back, {username}! Here is your activity overview.</p>
        </div>
      </div>

      <div className="staff-header-right">
       

        <div className="staff-header-date">
          <CalendarOutlined />
          <span>{currentDate}</span>
        </div>
{/* 
        <Dropdown menu={notificationsMenu} trigger={["click"]} placement="bottomRight"
          overlayClassName="staff-notif-dropdown">
          <div className="staff-notif-btn">
            <Badge count={5} size="small">
              <BellOutlined className="staff-bell-icon" />
            </Badge>
          </div>
        </Dropdown> */}

        <Dropdown menu={profileMenu} trigger={["click"]} placement="bottomRight"
          overlayClassName="staff-profile-dropdown">
          <div className="staff-header-profile">
            <Avatar size={36} icon={<UserOutlined />} className="staff-header-avatar" />
            <div className="staff-header-profile-info">
              <div className="staff-header-username">{username}</div>
              <div className="staff-header-role">Matchmaker Staff</div>
            </div>
            <DownOutlined className="staff-header-dropdown-icon" />
          </div>
        </Dropdown>
      </div>
    </header>
  );
}

export default StaffTopHeader;